module.exports = __webpack_public_path__ + "85c48a76f94948978cee45742a2c3192.pdf";